import moment from "moment";

export const headingData = [
    {
      id: 1,
      title: 'Vehicle No.',
      width: 145,
      showLine: true,
    },
    {
      id: 2,
      title: 'TXN DATE',
      width: 125,
      showLine: true,
    },
    {
      id: 3,
      title: 'TXN TIME',
      width: 125,
      showLine: true,
    },
    {
      id: 4,
      title: 'TXN ID',
      width: 185,
      showLine: true,
    },
    {
      id: 5,
      title: 'TXN TYPE',
      width: 230,
      showLine: true,
    },
    {
      id:6,
      title: 'PLAZA NAME',
      width: 230,
      showLine: true,
    },
    {
      id: 7,
      title: 'DEBIT AMOUNT',
      width: 125,
      showLine: true,
    },
    {
      id: 8,
      title: 'CREDIT AMOUNT',
      width: 125,
      showLine: false,
    },
  ];

  export const CLOSE_TAG_REASONS = [
    {
      key: "I have already sold my vehicle",
      text: "I have already sold my vehicle",
      val: 1
    },
    {
      key: "I am unhappy with the service",
      text: "I am unhappy with the service",
      val: 2
    },
    
    {
      key: "Force closure by NPCI",
      text: "Force closure by NPCI",
      val: 4
    },
    {
      key: "My FASTag is lost/stolen/damaged",
      text: "My FASTag is lost/stolen/damaged",
      val: 3
    },
    {
      key: "I am giving my vehicle to a friend or relative",
      text: "I am giving my vehicle to a friend or relative",
      val: 6
    },
    {
      key: "Others",
      text: "Others",
      val: 5
    },
   
   
  ];
export const ProofTypes = [
  {
    value: "Driving License",
    key: "DL",
    id: 1
  },
  {
    value: "Voter Card",
    key: "Voter",
    id: 2
  },
  {
    value: "Passport",
    key: "Passport",
    id: 3
  },
]
export const AccountTypeData = [
  {
    value: "Savings Account",
    id: 1
  },
  {
    value: "Current Account",
    id: 2
  },
]
export const AADHAR_MOBILE_CONFIRMATION = [
  {
    key: "Yes",
    text: "Yes",
    val: 1
  },
  {
    key: "No",
    text: "NO",
    val: 2
  },
];
export const ucl_offer_data = [
  {
    headLine: 'Car Loan',
    banner: require("../assets/images/UCL_MOBILE.png"),
    actionTxt: "https://firstforward.idfcfirstbank.com/",
    desc: [
      { title: "What is Offer?" },
      { title: "Offer Eligibility", description: "yes" },
    ],
  },]
export const ucl_offer_data_web = [
  {
    headLine: 'Car Loan',
    actionTxt: "https://firstforward.idfcfirstbank.com/",
    desc: [
      { title: "What is Offer?" },
      { title: "Offer Eligibility", description: "yes" },
    ],
  },]
  export const VEHICLE_NBR_TYPE = [
    {
      key: "RC Number",
      text: "RC Number",
    },
  ];

  export const AMOUNT_TYPE = [
    {
      key: "Full Amount",
      text: "Full Amount",
    },
    {
      key: "Partial Amount",
      text: "Partial Amount",
    },
  ];

  export const STATEMENT_TYPE = [
    {
      key: "Mini Statement",
      text: "Mini Statement",
    },
    {
      key: "Complete Statement",
      text: "Complete Statement",
    },
  ];
  export const FILTER_STATEMENT_TYPE = [
    {
      key: "Debit",
      text: "Debit",
    },
    {
      key: "Credit",
      text: "Credit",
    },
    {
      key: "Both",
      text: "Both",
    },
  ];
  export const PERIOD_STATEMENT_TYPE = [
    {
      key: "Last 1 Month",
      text: "Last 1 Month",
      val: 1,
    },
    // {
    //   key: "Last 3 Months",
    //   text: "Last 3 Months",
    //   val: 3,
    // },
  ];

export const changeDateFormat = (date)=>{
 return moment(date).format('DD-MM-YYYY');
}
const amountPattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;
